import dayjs from "dayjs";

export const CHART_COLORS = {
  inbox: "#4A5A61",
  spam: "#E85D75",
  confirmed: "#2DB8A0",
  pending_confirm: "#BFBFBF",
  rejected: "#E85D75",
  spamStatus: "#E85D75",
};

const STATUS_LABELS = {
  confirmed: "Confirmed",
  pending_confirm: "Pending",
  spam: "Spam",
  rejected: "Rejected",
};

export function formatChartDate(isoDate) {
  return dayjs(isoDate).format("MM/DD");
}

/** Fill missing days so line/bar charts show a continuous axis. */
export function fillDaySeries(days, endDate, rows, getValue) {
  const map = new Map(
    (rows || []).map((row) => {
      const key = row.date || row._id;
      return [key, row];
    }),
  );
  const end = dayjs(endDate || undefined);
  const out = [];
  for (let i = days - 1; i >= 0; i--) {
    const date = end.subtract(i, "day").format("YYYY-MM-DD");
    const row = map.get(date);
    out.push({ date, ...getValue(row, date) });
  }
  return out;
}

/** Wide rows for Recharts line chart (last 30 days). */
export function buildSubmissionsLineData(timeline, days = 30) {
  const filled = fillDaySeries(days, undefined, timeline, (row) => ({
    inbox: row?.inbox ?? 0,
    spam: row?.spam ?? 0,
  }));
  return filled.map(({ date, inbox, spam }) => ({
    date,
    label: formatChartDate(date),
    inbox,
    spam,
  }));
}

/** Wide rows for Recharts stacked bar chart (last 30 days). */
export function buildStatusBarData(statusPerDay, days = 30) {
  const byDate = new Map();
  for (const row of statusPerDay || []) {
    const date = row._id?.date;
    const status = row._id?.status || "confirmed";
    if (!date) continue;
    if (!byDate.has(date)) byDate.set(date, {});
    byDate.get(date)[status] = row.count;
  }

  const filled = fillDaySeries(days, undefined, null, (_, date) => {
    const counts = byDate.get(date) || {};
    return { counts };
  });

  return filled.map(({ date, counts }) => ({
    date,
    label: formatChartDate(date),
    [STATUS_LABELS.confirmed]: counts.confirmed ?? 0,
    [STATUS_LABELS.pending_confirm]: counts.pending_confirm ?? 0,
    [STATUS_LABELS.spam]: counts.spam ?? 0,
    [STATUS_LABELS.rejected]: counts.rejected ?? 0,
  }));
}

export function hasChartActivity(rows, keys) {
  return (rows || []).some((row) => keys.some((k) => (row[k] ?? 0) > 0));
}
